/* BERVAUX v4 — minimal, dependency-free.
   All handlers are delegated at document level so they survive
   Shopify theme-editor section re-renders (shopify:section:load). */
(function () {
  'use strict';

  var doc = document;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  /* ---------- Toast ---------- */
  var toastEl = null, toastTimer = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = doc.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      doc.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.setAttribute('data-show', '');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.removeAttribute('data-show'); }, 2800);
  }

  /* ---------- Focus trap ---------- */
  function trapFocus(container, e) {
    var focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- Bag drawer (looked up fresh — editor-safe) ---------- */
  var lastFocused = null;
  var drawerHideTimer = null;

  function drawerRoot() { return $('[data-drawer-root]'); }

  function openDrawer() {
    var root = drawerRoot();
    if (!root) return;
    clearTimeout(drawerHideTimer);
    lastFocused = doc.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.setAttribute('data-open', ''); });
    doc.body.style.overflow = 'hidden';
    var closeBtn = $('[data-drawer-close]', root);
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var root = drawerRoot();
    if (!root || !root.hasAttribute('data-open')) return;
    root.removeAttribute('data-open');
    doc.body.style.overflow = '';
    clearTimeout(drawerHideTimer);
    drawerHideTimer = setTimeout(function () {
      if (!root.hasAttribute('data-open')) root.hidden = true;
    }, 350);
    if (lastFocused && doc.contains(lastFocused)) lastFocused.focus();
  }

  function syncCountsFrom(root) {
    var n = root.getAttribute('data-item-count');
    if (n === null) return;
    $$('[data-bag-count]').forEach(function (el) {
      el.textContent = n;
      var link = el.closest('[data-bag-link]');
      if (link) link.setAttribute('aria-label', 'Bag, ' + n + ' items');
    });
  }

  /* Replace the drawer contents with freshly rendered section HTML.
     Returns false when the HTML is unusable so callers can fall back. */
  function renderDrawer(html, open) {
    var root = drawerRoot();
    if (!html || !root) return false;
    var tmp = doc.createElement('div');
    tmp.innerHTML = html;
    var fresh = $('[data-drawer-root]', tmp);
    if (!fresh) return false;
    var wasOpen = root.hasAttribute('data-open');
    var hadFocusInside = root.contains(doc.activeElement);
    // Capture the invoking control (e.g. Add to Bag) for focus-return, before the
    // innerHTML swap destroys it — but only when opening a drawer that was closed
    // and focus is outside it, so an already-stored trigger is never clobbered.
    if (open && !wasOpen && !hadFocusInside) lastFocused = doc.activeElement;
    root.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-item-count');
    if (count !== null) root.setAttribute('data-item-count', count);
    syncCountsFrom(root);
    if (wasOpen || open) {
      clearTimeout(drawerHideTimer);
      root.hidden = false;
      root.setAttribute('data-open', '');
      doc.body.style.overflow = 'hidden';
      if (hadFocusInside || open) {
        var closeBtn = $('[data-drawer-close]', root);
        if (closeBtn) closeBtn.focus();
      }
    }
    return true;
  }

  function refreshDrawer(open) {
    return fetch(window.location.pathname + '?sections=bag-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('sections fetch failed');
        return r.json();
      })
      .then(function (sections) {
        if (!renderDrawer(sections['bag-drawer'], open)) throw new Error('no drawer html');
      })
      .catch(function () {
        // Section rendering unavailable — still confirm the add.
        updateBagCount();
        if (open) toast('Added to your bag');
      });
  }

  function updateBagCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-bag-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          var link = el.closest('[data-bag-link]');
          if (link) link.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' items');
        });
      })
      .catch(function () {});
  }

  var cartBusy = false;

  function changeLine(key, qty) {
    if (cartBusy) return;
    cartBusy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: qty,
        sections: 'bag-drawer',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        if ($('[data-cart-page]')) { window.location.reload(); return null; }
        return r.json().then(function (j) {
          // Same-request section rendering: survives cookie-less editor previews.
          if (j.sections && renderDrawer(j.sections['bag-drawer'], false)) return null;
          return refreshDrawer(false);
        });
      })
      .catch(function () { toast('Could not update your bag. Please try again.'); })
      .finally(function () { cartBusy = false; });
  }

  /* item: {id, quantity}. Resolves true on success, false on failure. */
  function addToBag(item, trigger) {
    if (cartBusy) return Promise.resolve(false);
    cartBusy = true;
    if (trigger) trigger.setAttribute('aria-disabled', 'true');
    var opts = {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: 'bag-drawer',
        sections_url: window.location.pathname
      })
    };
    return fetch('/cart/add.js', opts)
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(
            function (j) { throw new Error(j.description || j.message || 'Could not add to bag'); },
            function () { throw new Error('Could not add to bag'); }
          );
        }
        if ($('[data-cart-page]')) { window.location.reload(); return true; }
        return r.json().then(function (j) {
          // Same-request section rendering: survives cookie-less editor previews.
          if (j.sections && renderDrawer(j.sections['bag-drawer'], true)) return true;
          return refreshDrawer(true).then(function () { return true; });
        });
      })
      .catch(function (err) {
        toast(err.message || 'Could not add to bag.');
        return false;
      })
      .finally(function () {
        cartBusy = false;
        if (trigger) trigger.removeAttribute('aria-disabled');
      });
  }

  /* ---------- Delegated: clicks ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]') || t.closest('[data-drawer-overlay]')) { e.preventDefault(); closeDrawer(); return; }

    var removeBtn = t.closest('[data-line-remove]');
    if (removeBtn) { e.preventDefault(); changeLine(removeBtn.getAttribute('data-line-remove'), 0); return; }

    var qtyBtn = t.closest('[data-line-qty]');
    if (qtyBtn) {
      e.preventDefault();
      changeLine(qtyBtn.getAttribute('data-line'), parseInt(qtyBtn.getAttribute('data-line-qty'), 10));
      return;
    }

    var upsellBtn = t.closest('[data-upsell-add]');
    if (upsellBtn) {
      e.preventDefault();
      if (upsellBtn.getAttribute('aria-disabled') === 'true') return;
      var fallbackId = parseInt(upsellBtn.getAttribute('data-upsell-add'), 10);
      var handle = upsellBtn.getAttribute('data-upsell-handle');
      if (handle) {
        // Resolve the variant live from the product handle so the added product
        // can never diverge from the one displayed on the tile.
        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            if (!r.ok) throw new Error('product fetch failed');
            return r.json();
          })
          .then(function (p) {
            var v = p.variants.find(function (variant) { return variant.available; }) || p.variants[0];
            return addToBag({ id: v.id, quantity: 1 }, upsellBtn);
          })
          .catch(function () { addToBag({ id: fallbackId, quantity: 1 }, upsellBtn); });
      } else {
        addToBag({ id: fallbackId, quantity: 1 }, upsellBtn);
      }
      return;
    }

    var step = t.closest('[data-qty-step]');
    if (step) {
      var input = $('input', step.closest('.qty'));
      if (input && !input.readOnly) {
        var next = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (t.closest('[data-search-open]')) {
      var panel = $('[data-search-panel]');
      if (panel) {
        panel.setAttribute('data-open', '');
        var si = $('input[type="search"]', panel);
        if (si) si.focus();
      }
      return;
    }
    if (t.closest('[data-search-close]')) {
      var panelC = $('[data-search-panel]');
      if (panelC) panelC.removeAttribute('data-open');
      return;
    }

    var menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      var nav = $('[data-mobile-nav]');
      if (nav) {
        var open = nav.hasAttribute('data-open');
        if (open) nav.removeAttribute('data-open'); else nav.setAttribute('data-open', '');
        menuBtn.setAttribute('aria-expanded', String(!open));
      }
      return;
    }

    var zoomBtn = t.closest('[data-lightbox-src]');
    if (zoomBtn) { openLightbox(zoomBtn); return; }

    var lb = $('[data-lightbox]');
    if (lb && lb.open) {
      if (t.closest('[data-lb-close]') || t === lb) lb.close();
      if (t.closest('[data-lb-prev]')) stepLightbox(-1);
      if (t.closest('[data-lb-next]')) stepLightbox(1);
    }

    var stickyBtn = t.closest('[data-sticky-add]');
    if (stickyBtn) {
      var form = $('form[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  /* ---------- Delegated: product form submit ---------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-product-form]') : null;
    if (!form) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var idInput = $('input[name="id"]', form);
    var qtyInput = $('input[name="quantity"]', form);
    if (!idInput || !idInput.value) return;
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    // Explicit id+quantity: immune to injected/duplicate form fields.
    addToBag({
      id: parseInt(idInput.value, 10),
      quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1
    }).then(function (ok) {
      if (!btn) return;
      if (ok) {
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200);
      } else {
        btn.textContent = original;
        btn.disabled = false;
      }
    });
  });

  /* ---------- Delegated: variant change + facet auto-submit ---------- */
  doc.addEventListener('change', function (e) {
    var facetForm = e.target.closest ? e.target.closest('[data-facet-form]') : null;
    if (facetForm) {
      if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') facetForm.submit();
      else debouncedFacetSubmit(facetForm);
      return;
    }

    if (!e.target.closest('.variant-options')) return;
    var wrap = e.target.closest('[data-product-info]') || doc;
    var script = $('[data-variant-json]', wrap);
    var form = $('form[data-product-form]', wrap);
    if (!script || !form) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (err) { return; }
    var selected = $$('.variant-options input:checked', wrap).map(function (i) { return i.value; });
    var v = variants.find(function (variant) {
      return selected.every(function (opt, i) { return variant.options[i] === opt; });
    });
    var btn = $('[type="submit"]', form);
    if (!v) {
      // No variant matches this option combination — make adding impossible.
      if (btn) {
        btn.disabled = true;
        btn.textContent = btn.getAttribute('data-label-soldout') || 'Unavailable';
      }
      return;
    }
    var idInput = $('input[name="id"]', form);
    if (idInput) idInput.value = v.id;
    var priceEl = $('[data-price]', wrap);
    if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
    if (btn) {
      btn.disabled = !v.available;
      btn.textContent = v.available
        ? btn.getAttribute('data-label-add') || 'Add to Bag'
        : btn.getAttribute('data-label-soldout') || 'Back soon';
    }
  });

  var debouncedFacetSubmit = debounce(function (form) { form.submit(); }, 600);

  /* ---------- Keyboard ---------- */
  doc.addEventListener('keydown', function (e) {
    var root = drawerRoot();
    if (e.key === 'Escape') {
      closeDrawer();
      var panel = $('[data-search-panel]');
      if (panel) panel.removeAttribute('data-open');
    }
    if (e.key === 'Tab' && root && root.hasAttribute('data-open')) trapFocus(root, e);
    var lb = $('[data-lightbox]');
    if (lb && lb.open) {
      if (e.key === 'ArrowLeft') stepLightbox(-1);
      if (e.key === 'ArrowRight') stepLightbox(1);
    }
  });

  /* ---------- Lightbox (state read from DOM — editor-safe) ---------- */
  var lightboxIndex = 0;

  function lightboxSources() {
    return $$('[data-lightbox-src]').map(function (el) {
      return { src: el.getAttribute('data-lightbox-src'), alt: el.getAttribute('data-lightbox-alt') || '' };
    });
  }

  function openLightbox(trigger) {
    var lb = $('[data-lightbox]');
    if (!lb || typeof lb.showModal !== 'function') return;
    var sources = lightboxSources();
    lightboxIndex = Math.max(0, $$('[data-lightbox-src]').indexOf(trigger));
    showLightbox(sources);
    lb.showModal();
  }

  function stepLightbox(dir) {
    var sources = lightboxSources();
    if (!sources.length) return;
    lightboxIndex = (lightboxIndex + dir + sources.length) % sources.length;
    showLightbox(sources);
  }

  function showLightbox(sources) {
    var lb = $('[data-lightbox]');
    var img = lb && $('.lightbox__img', lb);
    if (!img || !sources[lightboxIndex]) return;
    img.src = sources[lightboxIndex].src;
    img.alt = sources[lightboxIndex].alt;
  }

  /* ---------- Observers (re-initialized on editor re-renders) ---------- */
  var stickyObserver = null;

  function initStickyAtc() {
    var sticky = $('[data-sticky-atc]');
    var mainAtc = $('[data-main-atc]');
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    if (!sticky || !mainAtc || !('IntersectionObserver' in window)) return;
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          sticky.removeAttribute('data-visible');
          sticky.setAttribute('aria-hidden', 'true');
          sticky.setAttribute('inert', '');
        } else if (entry.boundingClientRect.top < 0) {
          sticky.setAttribute('data-visible', '');
          sticky.removeAttribute('aria-hidden');
          sticky.removeAttribute('inert');
        }
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainAtc);
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var ioDelivered = false;
    var revealer = new IntersectionObserver(function (entries) {
      ioDelivered = true;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealer.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal:not(.is-visible)').forEach(function (el) { revealer.observe(el); });
    // Content must never stay hidden if the observer misbehaves — reveal is cosmetic only.
    setTimeout(function () {
      if (ioDelivered) return;
      revealer.disconnect();
      $$('.reveal:not(.is-visible)').forEach(function (el) { el.classList.add('is-visible'); });
    }, 1200);
  }

  function init() {
    initStickyAtc();
    initReveal();
    updateBagCount();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: sections are re-rendered in place — re-init element-bound behavior.
  doc.addEventListener('shopify:section:load', init);
})();
